export default {
  PRIORITY_ERROR: 'ERROR',
  SIGN_IN_UNSUCCESSFUL: 'SIGN_IN_UNSUCCESSFUL',
  NEED_HELP: 'NEED_HELP',
};

export const MODIFY_RENTAL_ERRORS = {
  CREDIT_CARD: 'FRCLTW00122',
};
